<div class="application-section">
    <div class="logo-section">
        <img class="logo-1" src = "assets/images/logo/WorklogLogo.svg">
        <div class="description">
            <strong>WorkLog est une application web puissante conçue pour aider les professionnels à gérer et suivre leur temps de travail de manière efficace.  </strong>
            <a class="access-btn" href="https://worklog.fr" target="_blank">Accéder</a>
        </div>
    </div>

    <div class="worklog-container-1">
        <div class="picture-1">
                <div class="image-background"> 
                <img class="image-background" src="assets/images/worklog-description-imgs/picture-1.png">  
                </div>
                <div class="text-1">Personnalisez votre calendrier</div>
        </div>

        <div class="picture-2">
          <div class="image-background" > 
            <img class="image-background-1" src="assets/images/worklog-description-imgs/picture-2.png">  
           </div>          
        <div class="text-2">Boostez votre productivité </div>
        <img class="logo-2" src = "assets/images/logo/WorklogLogo.svg">

        </div>

        <div class="picture-3">
          <div class="image-background"> 
          <img class="image-background" src="assets/images/worklog-description-imgs/picture-3.png">  
          </div>
          <div class="text-1"> Des fonctionnalités adaptées à vos besoins </div>
  </div>

      </div>

      <div class="worklog-container-2">
        <div class="picture-1">
          <div class="image-background"> 
          <img class="image-background-2" src="assets/images/worklog-description-imgs/picture-4.png">  
          </div>
          <div class="text-3">Suivez votre temps de travail efficacement</div>
        </div>

        <div class="picture-1">
          <div class="image-background"> 
          <img class="image-background-3" src="assets/images/worklog-description-imgs/picture-5.png">  
          </div>
          <div class="text-4"> Découvrez notre 
            application mobile </div>
        </div>

        <div class="picture-1">
          <div class="image-background"> 
          <img class="image-background-4" src="assets/images/worklog-description-imgs/picture-6.png">  
          </div>
          <div class="text-5"> Gérez vos projets </div>
        </div>

      </div>      
</div>
    
    

